import axios from 'axios';

import { KanzhongBackend } from 'constant/KanzhongBackend';
import { ServerError, createApiError } from 'stores/ApiClientError';

// --- 型定義 ---

/** 子コメント */
export type ContractCommentChild = {
  contractCommentId: string;
  contractId: string;
  contractRequestId: string | null;
  comment: string;
  parentCommentId: string;
  createdAt: string;
  createdBy: string;
  createdByName: string;
};

/** 親コメント（子コメントをネスト） */
export type ContractCommentResult = {
  contractCommentId: string;
  contractId: string;
  contractRequestId: string | null;
  comment: string;
  createdAt: string;
  createdBy: string;
  createdByName: string;
  children: ContractCommentChild[];
};

/** コメント登録APIリクエスト */
export type CreateContractCommentParams = {
  contractId: string;
  contractRequestId?: string;
  comment: string;
  parentCommentId?: string;
};

/** コメント一覧取得APIリクエスト */
export type ListContractCommentParams = {
  contractId: string;
};

// --- API関数 ---

/**
 * 契約申請コメント登録API (API3510)
 * @param params.contractId - 契約ID（必須, 最大64文字）
 * @param params.contractRequestId - 契約申請ID（任意, 最大64文字, 契約申請画面からの場合に設定）
 * @param params.comment - コメント（必須, 最大10000文字）
 * @param params.parentCommentId - 親コメントID（任意, 最大64文字, 返信時に設定）
 */
export const createContractComment = async (params: CreateContractCommentParams): Promise<void> => {
  const sessionId = localStorage.getItem('session-id');

  try {
    await axios.post(KanzhongBackend.CREATE_CONTRACT_COMMENT, params, {
      headers: {
        'X-Session-Id': sessionId,
      },
    });
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      const { status, data } = error.response;
      throw createApiError(status, data?.message || error.message);
    }
    throw new ServerError();
  }
};

/**
 * 契約申請コメント取得API (API3511)
 * @param params.contractId - 契約ID（必須, 最大64文字）
 */
export const listContractComment = async (
  params: ListContractCommentParams,
): Promise<ContractCommentResult[]> => {
  const sessionId = localStorage.getItem('session-id');

  try {
    const response = await axios.post(KanzhongBackend.LIST_CONTRACT_COMMENT, params, {
      headers: {
        'X-Session-Id': sessionId,
      },
    });

    return response.data.results;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      const { status, data } = error.response;
      throw createApiError(status, data?.message || error.message);
    }
    throw new ServerError();
  }
};
